module.exports = __webpack_public_path__ + "static/media/undraw_mail_box_kd5i.2375c6af.png";